module.exports = __webpack_public_path__ + "img/card_at_referralcountstatus.464a45a2.svg";